import React from 'react';
import { useT } from '../utils/i18n';

const PaginationControls = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
  const t = useT();
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) {
    return null; // Don't show pagination if there's only one page or less
  }

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  // Simple pagination: Previous/Next buttons
  // You could expand this to show page numbers etc.
  return (
    <nav aria-label={t('Page navigation')} className="mt-3 d-flex justify-content-center">
      <ul className="pagination">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button className="page-link" onClick={handlePrevious} aria-label={t('Previous')}>
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        <li className="page-item disabled">
            <span className="page-link">{t('Page {current} of {total}', { current: currentPage, total: totalPages })}</span>
        </li>
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button className="page-link" onClick={handleNext} aria-label={t('Next')}>
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default PaginationControls;